import React from "react";
import { IconProps } from "../type";

export function Mail({
  size = 24,
  color = "currentColor",
  className = "",
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.7589 5.38284V14.8818C23.759 15.8503 23.3885 16.7821 22.7233 17.4861C22.0582 18.1901 21.1489 18.6128 20.1819 18.6677L19.9673 18.6735H4.21727C3.24877 18.6736 2.31696 18.303 1.613 17.6379C0.909026 16.9727 0.486263 16.0634 0.431432 15.0965L0.425598 14.8818V5.38284L11.6863 11.2815C11.8115 11.3471 11.9508 11.3814 12.0923 11.3814C12.2337 11.3814 12.373 11.3471 12.4983 11.2815L23.7589 5.38284ZM4.21727 0.00683597H19.9673C20.9071 0.00672275 21.8135 0.355664 22.5106 0.985981C23.2078 1.6163 23.646 2.48306 23.7403 3.41817L12.0923 9.51984L0.444265 3.41817C0.534709 2.5202 0.94249 1.68394 1.59431 1.05971C2.24612 0.435479 3.09923 0.0642208 4.00027 0.0126694L4.21727 0.00683597Z"
        fill={color}
      />
    </svg>
  );
}
